import { useUIStore } from '@/store/uiStore';
import TaskDetailModal from '@/components/tasks/TaskDetailModal.vue';

/**
 * Open the shared task detail modal (title, assignee, complete + links to deal/project).
 */
export function useTaskDetail() {
  const uiStore = useUIStore();

  const openTaskDetail = (task, { onUpdated, title } = {}) => {
    if (!task?.id) return null;

    const modalId = uiStore.addModal(TaskDetailModal, {
      title: title || task.title || '',
      size: 'md',
      taskId: task.id,
      initialTask: task,
      onSubmit: async (updated) => {
        if (typeof onUpdated === 'function') {
          await onUpdated(updated);
        }
      },
    });

    return modalId;
  };

  return { openTaskDetail };
}
